import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PharmaConnect from "@/pages/PharmaConnect";

export const Route = createFileRoute("/en/qbdpharmaconnect")({
  head: () => buildRouteHead("/en/qbdpharmaconnect"),
  component: PharmaConnect,
});

